import { render, staticRenderFns } from "./VoucherCarousel.vue?vue&type=template&id=4dcd2431&scoped=true"
import script from "./VoucherCarousel.vue?vue&type=script&lang=js"
export * from "./VoucherCarousel.vue?vue&type=script&lang=js"
import style0 from "./VoucherCarousel.vue?vue&type=style&index=0&id=4dcd2431&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd2431",
  null
  
)

export default component.exports